import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

const { accountNumbers } = CommonParameters;

export const directDebitSetUp_KRAKEN: IMcAppType = {
  name: "directDebitSetUp_KRAKEN",
  path: "/my/direct-debit/setup",
  parameters: {
    properties: { accountNumbers },
  },
  description: "Setup Direct Debit for a set of given accounts numbers",
  navFlow: NavFlow.FOCUS,
  title: "Manage Direct debit",
  parent: Tab.DASHBOARD, // Changed from Tab.MORE, Temporary workaround due to navigation issues on Mobile. See https://origindd.atlassian.net/browse/P21-2410

  conditions: {
    intent: "directDebitSetUp",
    customerType: CustomerType.kraken,
  },
};
